(function () {
  'use strict';

  var GUILD_TAG = 'is_guild';
  var INIT_FLAG = '__guild_guard_inited__';
  if (window[INIT_FLAG]) return;
  window[INIT_FLAG] = true;

  var BRAND_COLOR = '#09907a';

  function injectBannerStyles(){
    if (document.getElementById('guild-guard-banner-style')) return;
    var css = `
    .ggb-root{position:fixed;top:0;left:0;right:0;z-index:99999;display:flex;justify-content:center;pointer-events:none;padding-top:env(safe-area-inset-top,0)}
    .ggb-card{pointer-events:auto;box-shadow:0 10px 20px rgba(0,0,0,.12),0 6px 6px rgba(0,0,0,.08);border-radius:12px;margin:12px;max-width:720px;width:calc(100% - 24px);background:#111;color:#fff;overflow:hidden}
    .ggb-card[data-theme="light"]{background:#fff;color:#111;border:1px solid rgba(17,17,17,.08)}
    .ggb-row{display:flex;align-items:flex-start;gap:12px;padding:14px 16px}
    .ggb-icon{flex:0 0 auto;display:flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:8px;background:${BRAND_COLOR}}
    .ggb-title{font-weight:700;font-size:15px;line-height:1.2;margin:0}
    .ggb-text{font-size:14px;opacity:.9;margin-top:2px}
    .ggb-actions{margin-left:auto;display:flex;gap:8px}
    .ggb-btn{appearance:none;border:0;border-radius:10px;padding:8px 12px;font-size:13px;font-weight:600;cursor:pointer}
    .ggb-btn-primary{background:${BRAND_COLOR};color:#fff}
    .ggb-btn-ghost{background:transparent;color:inherit;opacity:.9}
    .ggb-btn:focus-visible{outline:2px solid ${BRAND_COLOR};outline-offset:2px}
    .ggb-close{margin-left:4px;background:transparent;border:0;color:inherit;opacity:.6;cursor:pointer;font-size:18px;line-height:1}
    .ggb-progress{height:3px;background:rgba(255,255,255,.2)}
    .ggb-card[data-theme="light"] .ggb-progress{background:rgba(17,17,17,.1)}
    .ggb-bar{height:100%;width:0;background:${BRAND_COLOR}}
    @media (prefers-reduced-motion: reduce){
      .ggb-bar{transition:none!important}
    }
    @media (max-width: 480px){
      .ggb-card{border-radius:0;margin:0;max-width:none;width:100%}
      .ggb-row{padding:12px 12px;gap:10px;flex-wrap:wrap}
      .ggb-icon{width:24px;height:24px;border-radius:6px}
      .ggb-title{font-size:14px}
      .ggb-text{font-size:13px}
      .ggb-actions{width:100%;margin-left:0;justify-content:flex-end;gap:6px}
      .ggb-btn{padding:8px 10px;font-size:12px;border-radius:8px}
      .ggb-close{display:none}
      .ggb-progress{height:2px}
    }`;
    var el = document.createElement('style');
    el.id = 'guild-guard-banner-style';
    el.textContent = css;
    document.head.appendChild(el);
  }

  function getThemeMode(){
    var dark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    return dark ? 'dark' : 'light';
  }

  function showGuildBanner(message, opts){
    injectBannerStyles();
    var redirectTo = (opts && opts.redirectTo) || '/checkout';
    var delayMs = Math.max(800, (opts && opts.delayMs) || 1800);

    var root = document.getElementById('ggb-root');
    if (!root){
      root = document.createElement('div');
      root.id = 'ggb-root';
      root.className = 'ggb-root';
      document.body.appendChild(root);
    }
    root.innerHTML = '';

    var card = document.createElement('div');
    card.className = 'ggb-card';
    card.setAttribute('data-theme', getThemeMode());
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'assertive');

    card.innerHTML = `
      <div class="ggb-row">
        <div class="ggb-icon" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 9v4m0 4h.01M12 2l10 18H2L12 2z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <p class="ggb-title">Heads up</p>
          <p class="ggb-text">${message}</p>
        </div>
        <div class="ggb-actions">
          <button class="ggb-btn ggb-btn-ghost" type="button" data-ggb-dismiss>Close</button>
          <button class="ggb-btn ggb-btn-primary" type="button" data-ggb-go>Go to checkout</button>
        </div>
        <button class="ggb-close" type="button" aria-label="Close" data-ggb-dismiss>&times;</button>
      </div>
      <div class="ggb-progress"><div class="ggb-bar"></div></div>
    `;

    root.appendChild(card);

    var bar = card.querySelector('.ggb-bar');
    requestAnimationFrame(function(){
      bar.style.transition = 'width '+delayMs+'ms linear';
      bar.style.width = '100%';
    });

    var closed = false;
    function cleanup(){ if (root && root.parentNode) root.parentNode.removeChild(root); }
    function go(){
      if (closed) return;
      closed = true;
      cleanup();
      window.location.href = redirectTo;
    }
    var t = setTimeout(go, delayMs);

    card.querySelectorAll('[data-ggb-dismiss]').forEach(function(btn){
      btn.addEventListener('click', function(){
        closed = true;
        clearTimeout(t);
        cleanup();
      });
    });
    card.querySelector('[data-ggb-go]').addEventListener('click', go);

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  var TAG_CACHE = new Map();
  var TAG_TTL_MS = 5 * 60 * 1000;
  var CART_CACHE = { value: null, ts: 0 };
  var CART_TTL_MS = 3500;

  function nowTs(){ return Date.now(); }
  async function safeJSON(res){ try{ return await res.json(); } catch(_) { return null; } }

  async function getProductJSONByHandle(handle){
    if(!handle) return null;
    var e = TAG_CACHE.get(handle);
    if(e && nowTs()-e.ts < TAG_TTL_MS) return e.json || null;
    var res = await fetch('/products/'+encodeURIComponent(handle)+'.js', { credentials:'same-origin' });
    var json = res.ok ? await safeJSON(res) : null;
    TAG_CACHE.set(handle, { json, ts: nowTs() });
    return json;
  }

  async function isGuildByHandle(handle){
    var p = await getProductJSONByHandle(handle);
    return !!(p && Array.isArray(p.tags) && p.tags.includes(GUILD_TAG));
  }

  async function cartHasGuild(){
    if (CART_CACHE.value !== null && nowTs()-CART_CACHE.ts < CART_TTL_MS) return CART_CACHE.value;
    var res = await fetch('/cart.js', { credentials:'same-origin' });
    if (!res.ok) { CART_CACHE = { value:false, ts: nowTs() }; return false; }
    var cart = await safeJSON(res);
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      CART_CACHE = { value:false, ts: nowTs() }; return false; }
    var propHit = cart.items.some(function(li){
      var props = li && li.properties;
      if (!props) return false;
      var v = props._guild || props['_guild'];
      return v === true || v === 'true' || v === '1' || v === 1;
    });
    if (propHit) { CART_CACHE = { value:true, ts: nowTs() }; return true; }
    var handles = Array.from(new Set(cart.items.map(function(i){ return i && i.handle; }).filter(Boolean)));
    var checks = await Promise.all(handles.map(isGuildByHandle));
    var has = checks.some(Boolean);
    CART_CACHE = { value:has, ts: nowTs() };
    return has;
  }

  async function parseBodyForSignals(body, headers){
    var handle = null, guildFlag = false;
    function truthy(v){ return v === true || v === 'true' || v === '1' || v === 1; }

    try {
      if (typeof URLSearchParams !== 'undefined' && (typeof body === 'string' || body instanceof URLSearchParams)) {
        var params = body instanceof URLSearchParams ? body : new URLSearchParams(body);
        handle = params.get('handle') || handle;
        var propGuild = params.get('properties[_guild]');
        if (propGuild != null) guildFlag = truthy(propGuild);
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var p = new URLSearchParams();
        for (var kv of body.entries()) p.append(kv[0], kv[1]);
        handle = p.get('handle') || handle;
        var propGuild2 = p.get('properties[_guild]');
        if (propGuild2 != null) guildFlag = truthy(propGuild2);
      }

      var ct = '';
      if (headers && typeof headers.get === 'function') ct = (headers.get('content-type') || '').toLowerCase();
      else if (headers && typeof headers === 'object') ct = (headers['Content-Type'] || headers['content-type'] || '').toLowerCase();

      if (!guildFlag && !handle) {
        if (typeof body === 'string' && (ct.includes('application/json') || /^[\{\[]/.test(body.trim()))) {
          var json = JSON.parse(body);
          if (json && json.properties && typeof json.properties === 'object') guildFlag = truthy(json.properties._guild);
          if (json && json.handle) handle = String(json.handle);
        } else if (body && typeof body === 'object' && !(body instanceof Blob)) {
          var j = body;
          if (j.properties && typeof j.properties === 'object') guildFlag = truthy(j.properties._guild);
          if (j.handle) handle = String(j.handle);
        }
      }
    } catch(_) {}

    return { handle: handle || null, guildFlag: !!guildFlag };
  }

  function looksLikeCartAdd(url){
    try{
      var u = (typeof url==='string') ? new URL(url, location.origin)
            : (url instanceof URL ? url : new URL(url.url, location.origin));
      return (/\/cart\/add(\.js)?$/i).test(u.pathname);
    }catch(_){ return false; }
  }

  function blockAndRedirect(){
    showGuildBanner('You already have a Guild item in your cart. We’re taking you to checkout to finish that order.', {
      redirectTo: '/checkout',
      delayMs: 1800
    });
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = (form.getAttribute('action')||'').toLowerCase();
    if (!action.includes('/cart/add')) return;
  }, true);

  (function setupFetchGate(){
    if (!window.fetch) return;
    var orig = window.fetch;
    window.fetch = async function(input, init){
      try{
        var method = (init && init.method ? String(init.method) : (input && input.method) || 'GET').toUpperCase();
        var url = (typeof input==='string' || input instanceof URL) ? input : (input && input.url) || '';
        if (method === 'POST' && looksLikeCartAdd(url)) {
          var headers = (init && init.headers) || (input && input.headers) || null;
          var body = init && init.body;
          var signals = await parseBodyForSignals(body, headers);
          var addingIsGuild = signals.guildFlag || (signals.handle ? await isGuildByHandle(signals.handle) : false);

          if (addingIsGuild && await cartHasGuild()) {
            blockAndRedirect();
            return new Response('{"blocked":true}', { status: 409, headers: { 'Content-Type':'application/json' } });
          }
        }
      }catch(_){}
      return orig.apply(this, arguments);
    };
  })();

  (function setupXHRGate(){
    var XHR = window.XMLHttpRequest;
    if (!XHR) return;
    var oOpen = XHR.prototype.open;
    var oSend = XHR.prototype.send;

    XHR.prototype.open = function(method, url){
      this.__g_m = (method||'GET').toUpperCase();
      this.__g_u = url;
      this.__g_h = this.__g_h || {};
      return oOpen.apply(this, arguments);
    };
    var oSetHeader = XHR.prototype.setRequestHeader;
    XHR.prototype.setRequestHeader = function(k, v){
      try { this.__g_h = this.__g_h || {}; this.__g_h[k] = v; } catch(_) {}
      return oSetHeader.apply(this, arguments);
    };
    XHR.prototype.send = function(body){
      var self = this;
      if (self.__g_m==='POST' && looksLikeCartAdd(self.__g_u)) {
        (async function(){
          try{
            var signals = await parseBodyForSignals(body, self.__g_h);
            var addingIsGuild = signals.guildFlag || (signals.handle ? await isGuildByHandle(signals.handle) : false);
            if (addingIsGuild && await cartHasGuild()) {
              try{ self.abort(); }catch(_){}
              return blockAndRedirect();
            }
          }catch(_){}
          oSend.call(self, body);
        })();
        return;
      }
      return oSend.apply(this, arguments);
    };
  })();
})();
